
/**
 * Constants
 */
import { InvestmentAccountType } from "./proto/investment_accounts";

const is_ira_type = account_type => {
  if (!account_type) {
    return false;
  }
  return [ 'ira', 'rollover_ira', 'roth_ira', 'sepp_ira', 'simple_ira'].includes(
    account_type.id);
}

const AccountTypeLabel = str => {
  if (str in InvestmentAccountType) {
    return InvestmentAccountType[str].label;
  }
  if (str === "UGMA") {
    return str;
  }
  return str;
}

const PortfolioPerforamnceType = {
  IN_BAND: { value: "IN_BAND", label: "In Bands" },
  UNDERPFORM: { value: "UNDERPEROFRM", label: "Underperformance" },
  OVERPERFORM: { value: "OVERPERFORM", label: "Overperformance" },
}

const PortfolioPerformanceLabel = str => {
  if (str in PortfolioPerforamnceType) {
    return PortfolioPerforamnceType[str].label;
  }
  return str;
}

const CustodianStatus = {
  UNVERIFIED: "unverified",
  VERIFIED: "verified",
}

// Advisory fee types
const ADVISORY_FEE = 0;
const SUB_ADVISORY_FEE = 1;

const DEV_SA_TABLE = "dev-super-admin";
const PROD_SA_TABLE = "prod-super-admin";


const SUPER_ADMIN = "S_ADMIN";
const WLF_ADMIN = "WLF_ADMIN";
const USER = "USER";

const DeveloperIdentityType = {
  UGMA_INVITEE: "UGMA_INVITEE",
}

// Account States
const ONBOARDING_STATE = 'ONBOARDING_STATE';
const ONBOARDING_PROXY_STATE = 'ONBOARDING_PROXY_STATE';
const HALF_SIGNED_STATE = 'HALF_SIGNED_STATE';
const SIGNED_STATE = 'SIGNED_STATE';
const SIGNED_PROXY_STATE = 'SIGNED_PROXY_STATE';
const TDA_REJECTED_STATE = 'TDA_REJECTED_STATE';
const TDA_CONFIRMED_STATE = 'TDA_CONFIRMED_STATE';
const LIVE_STATE = 'LIVE_STATE';
const TEST_PORTFOLIO_STATE = 'TEST_PORTFOLIO_STATE';
const TDA_PORTFOLIO_STATE = 'TDA_PORTFOLIO_STATE';
const PAYOUT_STATE = 'PAYOUT_STATE';
const CLOSED_STATE = 'CLOSED_STATE';

const AccountState = {
  ONBOARDING: ONBOARDING_STATE,
  ONBOARDING_PROXY: ONBOARDING_PROXY_STATE,
  HALF_SIGNED: HALF_SIGNED_STATE,
  SIGNED: SIGNED_STATE,
  SIGNED_PROXY: SIGNED_PROXY_STATE,
  TDA_REJECTED: TDA_REJECTED_STATE,
  TDA_CONFIRMED: TDA_CONFIRMED_STATE,
  LIVE: LIVE_STATE,
  TEST_PORTFOLIO: TEST_PORTFOLIO_STATE,
  TDA_PORTFOLIO: TDA_PORTFOLIO_STATE,
  PAYOUT: PAYOUT_STATE,
  CLOSED: CLOSED_STATE,

  RIA_PORTFOLIO: "RIA_PORTFOLIO_STATE",
  BROKERAGE_PORTFOLIO: "BROKERAGE_PORTFOLIO_STATE",
};

const AccountDerivedState = {
  ONBOARDING: "ONBOARDING",
  INITIAL_ALLOCATION: "INITIAL_ALLOCATION",
  ALLOCATED: "ALLOCATED",
  REBALANCE_REQUESTED: "REBALANCE_REQUESTED",
  ACCOUNT_PENDING: "ACCOUNT_PENDING",
  ACCOUNT_TRANSFER: "ACCOUNT_TRANSFER",
  STALE: "STALE",
  UNKNOWN: "UNKNOWN",
}

const SigningDoneResponses = {

  // User has finished signing, update AccountState
  // send confirmation email, and generate codes.
  SIGNED_USER: 'SIGNED_USER',

  // We have two people to sign, and we signed the first
  // one.
  SIGNED_FIRST_USER: 'SIGNED_FIRST_USER',

  // User has signed, but SMS verfication expired.
  // Regenerate the sms verification and resend.
  // SMS verification lives for a day.
  SMS_CONFIRMATION_RESENT: "SMS_CONFIRMATION_RESENT",

  // SMS code was already sent
  SMS_CONFIRMATION_SENT: "SMS_CONFIRMATION_SENT",

  // Envelope was not signed.
  ENVELOPE_NOT_SIGNED: 'ENVELOPE_NOT_SIGNED'
};


// Login states
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_NEW_PASSWORD = "LOGIN_NEW_PASSWORD";

// Execution information

// Running in a non-AWS environment, like a laptop.
const DEV_LOCAL = 'dev-local';
// Running in AWS environment with test data
const DEV_AWS = 'dev-aws';
// Running prod data on the laptop
const PROD_LOCAL = 'prod-local';
// Running in AWS environment with live data
const PROD_AWS = 'prod-aws';

const AWS_account_id = '792307060257';

const get_aws_region = () => {
  return "us-west-2";
};

const DEFAULT_SUBDOMAIN = "cleveralpha";

const ACCOUNT_FUNDING_PAYMENTS_CARD_TABLE_WIDTH = 1206;

const DEVICE = {
  tiny: "tiny",
  small: "small",
  medium: "medium",
  large: "large",
  x_large: "x_large",
  ultra_large: "ultra_large",
};

const DEVICE_WIDTH = {
  tiny: 0,
  small: 576,
  medium: 768,
  large: 992,
  x_large: 1200,
  ultra_large: 1920
};

const ORIENTATION = {
  PORTRAIT: "PORTRAIT",
  LANDSCAPE: "LANDSCAPE",
}

const GetDevice = width => {
  if (width >= DEVICE_WIDTH.ultra_large) {
    return DEVICE.ultra_large;
  }
    else if (width >= DEVICE_WIDTH.x_large) {
    return DEVICE.x_large;
  } else if (width >= DEVICE_WIDTH.large) {
    return DEVICE.large;
  } else if (width >= DEVICE_WIDTH.medium) {
    return DEVICE.medium;
  } else if (width >= DEVICE_WIDTH.small) {
    return DEVICE.small;
  }
  return DEVICE.tiny;
};

const SplitUsername = username => {
  const userRE = /^([^_]+)_(.+)$/;
  const match = username.match(userRE);
  if (!match) {
    return null;
  }
  return {
    wlf_id: match[1],
    email: match[2],
  }
}

const UGMA_INVITE_ID_FORMAT = "ugmaInvite_%04d";

const CREATE_REBALANCE_OP = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
}

const REBALANCE_OP = {
  REBALANCE: "Rebalance",
  ENGAGE_CASH: "Engage Cash"
}

const TWO_FACTOR_AUTH = true;

const AUTH_RESPONSE_STATE = {
  USERNAME_DOES_NOT_EXIST: "USERNAME_DOES_NOT_EXIST",
  TOO_MANY_ATTEMPTS: "TOO_MANY_ATTEMPTS",
  PASSWORD_SUCCESS: "PASSWORD_SUCCESS",
  PASSWORD_FAIL: "PASSWORD_FAIL",
  FIRST_OTP_SENT: "FIRST_OTP_SENT",
  SECOND_OTP_SENT: "SECOND_OTP_SENT",
  TOO_MANY_OTP_SENT: "TOO_MANY_OTP_SENT",
  OTP_FAIL: "OTP_FAIL",
  OTP_EXPIRE: "OTP_EXPIRE",
  TOO_MANY_OTP_FAIL: "TOO_MANY_OTP_FAIL",
  NO_PASSWORD: "NO_PASSWORD",
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  SUCCESS: "SUCCESS",
}

export { ADVISORY_FEE, SUB_ADVISORY_FEE, SUPER_ADMIN,
  WLF_ADMIN, USER, AccountState, AccountDerivedState,
  LOGIN_SUCCESS, LOGIN_NEW_PASSWORD, DEV_LOCAL,
  DEV_AWS, PROD_LOCAL, PROD_AWS,
  DEV_SA_TABLE, PROD_SA_TABLE, AWS_account_id, get_aws_region,
  DEFAULT_SUBDOMAIN, SigningDoneResponses, is_ira_type,
  ACCOUNT_FUNDING_PAYMENTS_CARD_TABLE_WIDTH,
  DEVICE_WIDTH, DEVICE, GetDevice, AccountTypeLabel, SplitUsername,
  UGMA_INVITE_ID_FORMAT, DeveloperIdentityType,
  CREATE_REBALANCE_OP, PortfolioPerforamnceType, PortfolioPerformanceLabel,
  REBALANCE_OP, TWO_FACTOR_AUTH, AUTH_RESPONSE_STATE,
  ORIENTATION, CustodianStatus };
